export default "__VITE_ASSET__CXuW21bR__"